import { useAtomValue } from 'jotai/index';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { useMemo } from 'react';
import { ArticleDetailUtil, EArticleUnavailableReason } from 'shared/models';
import { useTranslation } from 'react-i18next';
import { unescapeSpecialXmlCharacter } from '~/utils/escape-xml';
import { loadable } from 'jotai/utils';
import { $HitArticleGptTDK } from '~/utils/libra/article-gpt-tdk';
import { $CurrentArticleGPTInfo } from '../atoms/current-article-gpt-info';

export const useArticleDescription = (): string => {
  const loadableArticle = useAtomValue(loadable($CurrentArticle));
  const { t } = useTranslation();

  const hitArticleGptTDK = useAtomValue($HitArticleGptTDK);
  const gptInfo = useAtomValue($CurrentArticleGPTInfo);

  return useMemo(() => {
    if (loadableArticle.state !== 'hasData') {
      return '';
    }

    const article = loadableArticle.data;
    const articleAvailable = ArticleDetailUtil.isArticleAvailable(article);

    if (!articleAvailable) {
      if (article.unavailableReason === EArticleUnavailableReason.PRIVATE_ACCOUNT) {
        return t('privateAccount_web_description');
      }
      return t('article_not_found');
    }

    if (hitArticleGptTDK && gptInfo?.description) {
      return gptInfo.description;
    }

    const shortContent = article.shortContent;

    let description = unescapeSpecialXmlCharacter(shortContent).slice(0, 160).replace(/\s+/g, ' ').slice(0, 130);

    if (description.length < 30) {
      description = `${t('article_gallery_description').replace('%s', article.author.linkName)} | Lemon8`;
    }

    return description;
  }, [loadableArticle]);
};
